import React from "react";

import firstQuarterly2026 from "../../../../files/quarterly_reports/1st Quarter (Un-Audited-2026).pdf";
import firstQuarterly2025 from "../../../../files/quarterly_reports/1st Quarter (Un-Audited)-2025.pdf";
import firstQuarterly2024 from "../../../../files/quarterly_reports/1st Quarter (un-audited)-2024.pdf";
import firstQuarterly2023 from "../../../../files/quarterly_reports/img266.pdf";
import firstQuarterly2022 from "../../../../files/quarterly_reports/First Quarterly Report (Q1) as on 31.03.2022.pdf";
import firstQuarterly2021 from "../../../../files/quarterly_reports/1st Quarterly Report-2021.pdf";
import firstQuarterly2020 from "../../../../files/quarterly_reports/1st Quarterly Report-2020 (Un-audited).pdf";
import firstQuarterly2019 from "../../../../files/quarterly_reports/Rupali-Ins-29-04-19-page-001.jpg";
import firstQuarterly2018 from "../../../../files/quarterly_reports/Rupali-Ins-25-04-18_1.pdf";

import secondQuarterly2026 from "../../../../files/quarterly_reports/second_quarter_2026.pdf";
import secondQuarterly2025 from "../../../../files/quarterly_reports/Financial Statement- Rupali Insurance.pdf";
import secondQuarterly2024 from "../../../../files/quarterly_reports/2nd Quarter (Un-audited)-2024.pdf";
import HalfYearlyReport2023 from "../../../../files/quarterly_reports/Un-audited 2nd Quarter Report 2023.pdf";
import HalfYearlyReport2022 from "../../../../files/quarterly_reports/Un-audited Half Yearly Report July-2022.pdf";
import HalfYearlyReport2021 from "../../../../files/quarterly_reports/Un-audited Half yearly Report-2021.pdf";
import HalfYearlyReport2020 from "../../../../files/quarterly_reports/HalfYearlyReport2020.pdf";
import HalfYearlyReport2019 from "../../../../files/quarterly_reports/Un-audited Half Yearly Report-2019.pdf";
import HalfYearlyReport2018 from "../../../../files/quarterly_reports/Un-audited-Half-Yearly-Report-2018.pdf";

import thirdQuarterly2025 from "../../../../files/quarterly_reports/3rd-Quarterly-2025.pdf";
import thirdQuarterly2024 from "../../../../files/quarterly_reports/Un-audited Third Quarterly (Q3) Report - 2024.pdf";
import thirdReport2023 from "../../../../files/quarterly_reports/3rd Quarter (un-audited)-2023.pdf";
import thirdReport2022 from "../../../../files/quarterly_reports/3rd Quarterly Report 2022.pdf";
import thirdReport2021 from "../../../../files/quarterly_reports/3rd Quarterly Report-2021.pdf";
import thirdReport2020 from "../../../../files/quarterly_reports/3rd-Quarterly-Report-2020-Un-Audited.pdf";
import thirdReport2019 from "../../../../files/quarterly_reports/3rdQuarterlyReport-2019.pdf";
import thirdReport2018 from "../../../../files/quarterly_reports/3rd-Quarterly-Report-2018.pdf";

const QuarterlyReports = () => {
  return (
    <>
      <div className="row mt-5">
        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2026</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2026}>
                  1st Quarter (Un-audited)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={secondQuarterly2026}>
                  2nd Quarter (Un-audited)
                </a>
              </li>

              {/*  <li>
                <a target="_blank" rel="noreferrer" href={thirdQuarterly2025}>
                  3rd Quarter (Un-audited)
                </a>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2025</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2025}>
                  1st Quarter (Un-audited)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={secondQuarterly2025}>
                  2nd Quarter (Un-audited)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={thirdQuarterly2025}>
                  3rd Quarter (Un-audited)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2024</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2024}>
                  1st Quarter (Un-audited)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={secondQuarterly2024}>
                  {/* 2nd Quarter (un-audited) */}
                  2nd Quarter (Un-audited)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={thirdQuarterly2024}>
                  {/* 3rd Quarter (un-audited) */}
                  3rd Quarter (Un-audited)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2023</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2023}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2023}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a
                  aria-current="page"
                  target="_blank"
                  rel="noreferrer"
                  href={thirdReport2023}
                >
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2022</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2022}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2022}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={thirdReport2022}>
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2021</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2021}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2021}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={thirdReport2021}>
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2020</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2020}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2020}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={thirdReport2020}>
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2019</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2019}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2019}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={thirdReport2019}>
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2018</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={firstQuarterly2018}>
                  1st Quarter (un-audited)
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={HalfYearlyReport2018}>
                  2nd Quarter (un-audited){" "}
                </a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href={thirdReport2018}>
                  3rd Quarter (un-audited){" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuarterlyReports;
